import styled from 'styled-components';
import userCustomContent from 'styles/userCustomContent';
import BaseButton from '../../../../Button';
import Typography from '../../../../Typography';

export const Button = styled(BaseButton)`
  margin: 0 auto 20px;
  display: block;
  text-transform: uppercase;
`;

export const Title = styled(Typography).attrs({
  level: 'displayMd',
})`
  margin-bottom: 40px;
  margin-top: 20px;
  text-align: center;
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  ${userCustomContent}
`;
